import { render, staticRenderFns } from "./ReviewDialog.vue?vue&type=template&id=36fcc5a6&scoped=true"
import script from "./ReviewDialog.vue?vue&type=script&lang=js"
export * from "./ReviewDialog.vue?vue&type=script&lang=js"
import style0 from "./ReviewDialog.vue?vue&type=style&index=0&id=36fcc5a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fcc5a6",
  null
  
)

export default component.exports